import React from 'react'

import './button.scss'

export const Button = ( { position, label, link, new_tab } ) => {
    const positionClass = position && `button--${ position }`
    return (
        <a
            className={ [ `button`, positionClass ].join( ` ` ) }
            target={ new_tab ? `_blank` : undefined }
            rel={ new_tab ? `noopener noreferrer` : undefined }
            href={ link }>
            { label }
        </a>
    )
}